import LoopFront from "loop-front";
import { ActionCreator } from "Typings/Global";
import { DefinitionDialogFormProps } from "Features/Definitions/DefinitionDialogForm";

const CustomActions = {
    SHOW_DEFINITION_DIALOG_FORM: 'SHOW_DEFINITION_DIALOG_FORM',
    HIDE_DEFINITION_DIALOG_FORM: 'HIDE_DEFINITION_DIALOG_FORM',
}

const CustomActivities = {
    TOGGLE_PUBLISH: 'publish',
}

class Definition extends LoopFront<typeof CustomActions, {}, typeof CustomActivities> {
    constructor() {
        super('definitions', CustomActions, {}, CustomActivities);
    }

    showDefinitionForm = (props: Omit<DefinitionDialogFormProps, 'open'>): ActionCreator => dispatch => dispatch({ type: this.Actions.SHOW_DEFINITION_DIALOG_FORM, data: props });

    hideDialogForm = (): ActionCreator => dispatch => dispatch({ type: this.Actions.HIDE_DEFINITION_DIALOG_FORM });

}

export const DefinitionsModel = new Definition();